// 🔴 L2 (N°876) — SUIVI D'ÉTAPES du dossier artisan, RECONSTRUIT.
//
// ⚠️ Ce qu'il remplace : `PipelineStepper` demandait `tef_pipeline_amo` EN DUR et
// lisait `workflow_data.tef.pipeline_status` ; `DatesPipelineBlock` affichait
// les 9 étapes TEF/ANAH sans aucun filtre. Mario HÉRITAIT donc du parcours TEF.
// 🔑 Ici : le parcours DÉCLARÉ par le tenant (`/api/governance/pipelines`) et le
// `statut` du dossier. ⛔ Aucun pipeline TEF en repli, ⛔ aucune lecture de
// `workflow_data.tef`. Sans parcours déclaré : le statut, et la phrase qui le dit.
import { useEffect, useState } from "react";
import { useConfigList, configLabel } from "../../../hooks/useConfigList";
import { pipelinesDuTenant } from "./api";

export function SuiviEtapesArtisan({ dossier }) {
  const [etapes, setEtapes] = useState(null);
  const { items: statuts } = useConfigList("statuts_dossier");

  useEffect(() => {
    let vivant = true;
    pipelinesDuTenant()
      .then((r) => {
        const p = (r.pipelines || [])[0];
        const liste = [...((p && p.steps) || [])]
          .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
        if (vivant) setEtapes(liste);
      })
      .catch(() => vivant && setEtapes([]));
    return () => { vivant = false; };
  }, []);

  const statut = dossier?.statut || "";
  const libelle = configLabel(statuts, statut, statut || "—");
  const idx = (etapes || []).findIndex((s) => s.code === statut);

  return (
    <div data-testid="artisan-suivi">
      <div className="text-sm" style={{ color: "var(--oh-text-secondary)" }}>
        Statut : <span data-testid="artisan-statut" style={{ color: "var(--oh-text)" }}>{libelle}</span>
      </div>
      {etapes && etapes.length > 0 ? (
        <ol className="flex flex-wrap gap-2 mt-2" data-testid="artisan-etapes">
          {etapes.map((s, i) => (
            <li key={s.code} className="text-xs rounded-lg px-2 py-1"
                style={i === idx
                  ? { background: "var(--oh-accent-bg)", color: "var(--oh-accent-text)" }
                  : { background: "var(--oh-bg-surface)", color: "var(--oh-text-secondary)",
                      border: "0.5px solid var(--oh-border)" }}>
              {s.label || s.code}
            </li>
          ))}
        </ol>
      ) : etapes ? (
        <div className="text-xs mt-1" data-testid="artisan-etapes-aucune"
             style={{ color: "var(--oh-text-secondary)" }}>
          Aucun parcours d'étapes déclaré pour ce métier.
        </div>
      ) : null}
    </div>
  );
}

export default SuiviEtapesArtisan;
